import Quill from "quill";
// import Parchment from 'parchment';

const Parchment = Quill.import('parchment');

function sanitize(url, protocols) {
  let anchor = document.createElement('a');
  anchor.href = url;
  let protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

const ATTRIBUTES = [
  'alt',
  'title',
  'height',
  'width'
];

const STYLES = [
  // 'width',
  // 'height',
];

class ImageIcon extends Parchment.Embed {
  static create(value) {
    let node = super.create(value);
    if (typeof value === 'string') {
      node.setAttribute('src', this.sanitize(value));
    }
    return node;
  }

  static formats(domNode) {
    let formatsAttr = ATTRIBUTES.reduce(function(formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});

    let formatsStyle = STYLES.reduce(function(formats, style) {
      if (domNode.style[style]) {
        formats[style] = domNode.style[style];
      }
      return formats;
    }, {});

    return { ...formatsAttr, ...formatsStyle };
  }

  static match(url) {
    return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
  }

  static sanitize(url) {
    return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
  }

  static value(domNode) {
    return domNode.getAttribute('src');
  }

  format(name, value) {
    if (STYLES.indexOf(name) > -1) {
      if (value) {
        this.domNode.style[name] = value;
      } else {
        this.domNode.style[name] = undefined;
      }
    } else if (ATTRIBUTES.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }
}

ImageIcon.blotName = 'image-icon';
ImageIcon.className = 'img-icon';
ImageIcon.tagName = 'IMG';

export default ImageIcon;
